module.exports = __webpack_public_path__ + "static/media/Woolworths.fd0c07a8.jpg";